import { useAtom } from 'jotai'

import { commonContentPageLoadingStore } from 'src/stores'

export const useCommonContentPageLoadingStore = () => {
  const [commonContentPageLoadingStoreValue, setCommonContentPageLoadingStoreValue] = useAtom(
    commonContentPageLoadingStore.state
  )

  return {
    commonContentPageLoadingStoreValue,
    setCommonContentPageLoadingStoreValue,
  }
}
